import { createSlice, type PayloadAction, type WithSlice } from '@reduxjs/toolkit';

import {
  rootReducer,
  DATAGRID_INITIAL_PAGE,
  DATAGRID_INITIAL_PAGE_SIZE,
} from '@verantos-dev/core-annotation-tool';

export interface AnnotatorQueueState {
  projectId: string | null;
  batchId: string | null;
  projectsListPage: number;
  projectsListPageSize: number;
}

const initialState: AnnotatorQueueState = {
  projectId: null,
  batchId: null,
  projectsListPage: DATAGRID_INITIAL_PAGE,
  projectsListPageSize: DATAGRID_INITIAL_PAGE_SIZE,
};

const annotatorQueueSlice = createSlice({
  name: 'annotatorQueue',
  initialState,
  reducers: {
    setProjectId: (state, action: PayloadAction<string | null>) => {
      state.projectId = action.payload;
    },
    clearProjectId: (state) => {
      state.projectId = null;
    },
    setBatchId: (state, action: PayloadAction<string | null>) => {
      state.batchId = action.payload;
    },
    clearBatchId: (state) => {
      state.batchId = null;
    },
    setProjectsListPaginationModel: (
      state,
      action: PayloadAction<{ page: number; pageSize: number }>
    ) => {
      state.projectsListPage = action.payload.page;
      state.projectsListPageSize = action.payload.pageSize;
    },
  },
});

export const {
  setProjectId,
  clearProjectId,
  setBatchId,
  clearBatchId,
  setProjectsListPaginationModel,
} = annotatorQueueSlice.actions;

declare module '@verantos-dev/core-annotation-tool' {
  // WithSlice utility assumes reducer is under slice.reducerPath
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
  export interface LazyLoadedSlices extends WithSlice<typeof annotatorQueueSlice> {}
}

annotatorQueueSlice.injectInto(rootReducer);
